import React, { useState, useEffect } from 'react';
import axios from 'axios';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import ListItemIcon from '@mui/material/ListItemIcon';
import Button from '@mui/material/Button';
import CustomAvatar from '../Avatar/Avatar';
// import Icon from '@mui/material/Icon';
import { clearPersistentStorage } from '../../Utils/usePersistentStorage';
import UserProfileDialog from '../../pages/UserProfile/UserProfile';
import { useNavigate } from "react-router-dom";
import { closeSocket } from "../Main/Main";
import { getRandomColor, removeUserSession, getCompanyId, getToken, getUser } from '../../Utils/Common';
import './menu.scss';
import { MENU_LIST } from "../../constants/dropdown";

export default function CustomMenu() {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [selectedIndex, setSelectedIndex] = React.useState(null);
  const [showDialog, setShowDialog] = useState(false);
  const [appInfo, setAppInfo] = useState('');
  const [avatarColor, setAvatarColor] = useState('');
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (link, index, label) => {
    setSelectedIndex(index);
    if (label === "Logout") {
      handleLogout();
    } else if (label === 'My Profile') {
      handleShowProfile();
    }
    handleClose();
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDialogClose = () => {
    setShowDialog(false);
  };


  const handleLogout = async (props) => {
    closeSocket();
    // clear all keys set in localstorage
    clearPersistentStorage();
    // window.sessionStorage.clear();
    await removeUserSession();
    navigate('/');
  };

  const handleShowProfile = () => {
    setShowDialog(true)
  }

  const renderAvatar = () => {
    return (
      <CustomAvatar avatarColor={avatarColor} />
    )
  };

  const fetchData = async () => {
    const apiURL = `/api/fullVersion`;
    axios({
        method: "get", url: apiURL,
        headers: { "insightUserId": getUser(), "companyId": getCompanyId(), "Authorization": getToken() }
    })
        .then(response => {
            // console.log(response.data);
            const appData = response.data.split(" ");
    
            const info = {
                version: appData[0].split('-')[0],
                platform: appData[0].split(':')[1].toUpperCase(),
                envId: appData[0].split(':')[2],
                clusterId: appData[0].split(":")[3].split(/\r?\n/)[0]
            }
            let appVersion = info.version === 'null' ? "localhost" : info.version;
            setAppInfo(info);
            const menuLength = MENU_LIST.length - 1;
            MENU_LIST[menuLength].label = appVersion + ', ' + info.platform;
        }).catch(error => {
            console.log('error in api call:', error);
        });
  }

  useEffect(() => {
      let color = getRandomColor();
      fetchData();
      setAvatarColor(color);
  },[]);

  return (
    <>
      <Button
        id="basic-button"
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        className={'menu-button'}
      >
        {renderAvatar()}
      </Button>

      <Menu
        id="lock-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        className={'custom-menu-wrapper'}
      >
        {MENU_LIST.map((menuItem, index) => {
          return (
              <MenuItem
                className={'custom-menu-item'}
                title={menuItem.label}
                disabled={index === 3}
                divider={index === 2}
                selected={index === selectedIndex}
                key={menuItem.label}
                onClick={() => handleMenuItemClick(menuItem.link, index, menuItem.label)}
              >
                <ListItemIcon>
                  {menuItem.icon !== null && <menuItem.icon style={{ width: 24, height: 24 }} />}
                  {/* <Icon sx={{ color: menuItem.color }}>{menuItem.icon}</Icon> */}
                </ListItemIcon>
                {menuItem.label}
              </MenuItem>
          );
        })}
      {/* <MenuItem disabled style={{marginTop:'-20px'}}>
                {appInfo.platform} , {appInfo.envId}, {appInfo.clusterId}
      </MenuItem> */}
      <div className='appInfo'>
        <p>{appInfo.envId}, {appInfo.clusterId}</p>
      </div>
      </Menu>
      <UserProfileDialog
        open={showDialog}
        onClose={handleDialogClose}
        handleClose={handleDialogClose}
      />
    </>
  );
}
